import React, { Component } from 'react';
import './Input.css';
import Utils from '../../../base/Utils';

class Input extends Component {
    availableTypes = ['text', 'password', 'email', 'date', 'time', 'textarea'];
    availableStates = ['Active', 'ReadOnly', 'Disabled'];
    ref = null;
    onChangeCallback = null;
    
    constructor(props) {
        super(props);
        this.state = {value: (this.props.value || '')};
    }
    
    render() {
        var value = this.props.value || this.state.value;
        var clearCallback = this.props.clearCallback || function() { };
        var placeholder = this.props.placeholder || '';
        var label = this.props.label || '';
        var height = this.props.height + 'px' || '';
        this.onChangeCallback = this.props.onChange || function(){ };
        var getRef = this.props.getRef || function(){ };
        var type = Utils.checkAvailability(this.availableTypes, this.props.type, true);
        var state = Utils.checkAvailability(this.availableStates, this.props.state, true);
        
        var classValue = "Input " + state;
        var inputProps = {};
        
        switch(state) {
            case 'ReadOnly':
            inputProps.readOnly = "readonly";
            break;
            case 'Disabled':
            inputProps.disabled = "disabled";
            classValue += " Disabled";
            break;
            default:
        }
        
        inputProps.value = value;
        if(inputProps.value !== '') classValue += " Fielded";
        
        if(placeholder !== '') inputProps.placeholder = placeholder;
        
        clearCallback(() => this.clear());
        
        var html = <div className={classValue}>
        {(label !== '') ? <div className="InputLabel">{label}</div> : ''}
        <div className="InputArea">
        {React.cloneElement((type !== 'textarea')
        ? <input type={type} onChange={(e) => { this.onChange(); this.onChangeCallback(e.target); }} 
        ref={(input) => { this.getRef(input); getRef(input); }}/>
        : <textarea onChange={(e) => { this.onChange(); this.onChangeCallback(e.target); }} 
        ref={(input) => { this.getRef(input); getRef(input); }} style={{height:height}}>{inputProps.value}</textarea>, inputProps)}
        </div>
        </div>;
        
        return html;
    }
    
    getRef(ref) {
        this.ref = ref;
    }
    
    clear() {
        this.setState({
            value: ""
        });
        
        this.onChangeCallback(this.ref);
    }
    
    onChange() {
        this.setState({
            value: this.ref.value
        });
    }
}

export default Input;
